module.exports = "#madiv {\n  height: 800pt;\n  overflow-y: scroll;\n  display: block; }\n"